@if (showFaresBlock) {
  <div class="more-fares-wrapper">
    <table class="fares-table-container" aria-label="Fare details table">
      <thead>
        <tr>
          @if (!isExchange || isPricingExchange) {
            <th class="class-header">
              @if (isReturnFlight) {
                <span i18n="@@flightFiltersOutbound">Outbound</span>
              }
            </th>
            <th class="small-block" i18n="@@ShowDetailsHandBaggage">Hand baggage</th>
            <th class="small-block" i18n="@@ShowDetailsHoldBaggage">Hold baggage</th>
            <!-- We will need more changes here for Sabre, just show this for TFX for now(new ticket ENT-6375)-->
            @if (isTravelfusion) {
              <th aria-label="Refund" class="small-block" i18n="@@UpsellRefunds">Refunds</th>
            }
            @if (isTravelfusion) {
              <th class="small-block" i18n="@@railresultsheaderChanges">Changes</th>
            }
            @if (isReturnFlight) {
              <th class="border-left-mixed class-header" i18n="@@flightFiltersInbound">Inbound</th>
              <th class="small-block" i18n="@@ShowDetailsHandBaggage">Hand baggage</th>
              <th class="small-block" i18n="@@ShowDetailsHoldBaggage">Hold baggage</th>
            }
            <!-- We will need more changes here for Sabre, just show this for TFX for now(new ticket ENT-6375)-->
            @if (isTravelfusion && isReturnFlight) {
              <th class="small-block" i18n="@@UpsellRefunds">Refunds</th>
            }
            @if (isTravelfusion && isReturnFlight) {
              <th class="small-block" i18n="@@railresultsheaderChanges">Changes</th>
            }
          }
          @if (showNdc) {
            <th></th>
          }
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (flight of fares; track flight; let j = $index) {
          <tr>
            <td>
              <div class="cabin-class">
                {{ flight.outboundFlights[0].cabinClass | splitCamelCase | translate }}
                @if (flight.outboundFlights[0].additional.fareBrand?.name) {
                  <span
                    >({{ flight.outboundFlights[0].additional.fareBrand?.name | titlecase }})
                    @if (showSaverAerLingusTravelfusionTooltip(flight)) {
                      <span class="tooltip_wrap">
                        <section (mouseleave)="tt.close()" class="container">
                          <i
                            class="currency_info_icon"
                            placement="top"
                            triggers="manual"
                            #tt="ngbTooltip"
                            (mouseenter)="tt.open()"
                            (focus)="tt.open()"
                            (blur)="tt.close()"
                            i18n-ngbTooltip
                            tabindex="0"
                            ngbTooltip="The fare inclusive hand baggage option you have chosen doesn't allow you to take the bag onboard. You can check your bag in at the airport free of charge which will then go into the hold or you can pay a small fee to carry your bag with you and place it in the overhead locker."
                            aria-label="The fare inclusive hand baggage option you have chosen doesn't allow you to take the bag onboard. You can check your bag in at the airport free of charge which will then go into the hold or you can pay a small fee to carry your bag with you and place it in the overhead locker."
                          >
                          </i>
                        </section>
                      </span>
                    }
                  </span>
                }
                @if (showMixedCabin(flight.outboundFlights)) {
                  <app-mixed-cabin-tooltip
                    [flights]="flight.outboundFlights"
                  ></app-mixed-cabin-tooltip>
                }
              </div>
              <div class="seats-available">
                @if (flight.outboundFlights[0].seatsAvailable) {
                  <i class="ico-plain-seat" aria-hidden="true"></i>
                  <span>{{ flight.outboundFlights[0].seatsAvailable }}</span>
                  <span i18n="@@flight_seatsLeft" class="sr-only">Seats left</span>
                }
                @if (!flight.outboundFlights[0].seatsAvailable) {
                  <span i18n="@@flight_SeatsUnknown">Number of seats unknown</span>
                }
                @if (
                  (flight.outboundFlights[0]?.bookingCode ||
                    flight.outboundFlights[0]?.cabinCode) &&
                  userIsAgent
                ) {
                  <span>&nbsp;(</span>
                  <span>{{
                    flight.outboundFlights[0]?.bookingCode || flight.outboundFlights[0]?.cabinCode
                  }}</span>
                  @if (
                    flight.outboundFlights[0]?.bookingCode || flight.outboundFlights[0]?.cabinCode
                  ) {
                    <span>
                      /
                      {{
                        flight.outboundFlights[0]?.bookingCode ||
                          flight.outboundFlights[0]?.cabinCode
                      }}</span
                    >
                  }
                  <span>)</span>
                }
              </div>
              <button
                (click)="getRouteHappyInfo(flight, flight.outboundFlights)"
                [disabled]="loadingRouteHappy"
                class="routehappy_button"
              >
                <span class="visuallyhidden">Outbound&nbsp;</span>
                <span i18n="@@modalRoutehappyFlightDetail">Flight Details</span>
                <span class="visuallyhidden">&nbsp;for {{ visuallyHiddenTexts[j] }} fare</span>
              </button>
            </td>
            @if (!isExchange || isPricingExchange) {
              <td>
                <app-ancillary-status-icon
                  [isReturnFlight]="isReturnFlight"
                  [ancillaryStatus]="transformedFareAncillaries[j].hangBaggage"
                ></app-ancillary-status-icon>
              </td>
              <td>
                <b
                  >{{ searchParams.getTotalBaggage(flight) }}
                  @if (searchParams.getTotalBaggage(flight) !== 1) {
                    <span>
                      <span i18n="@@bags">bags</span>
                    </span>
                  } @else {
                    <span i18n="@@bag">bag</span>
                  }
                </b>
              </td>
            }
            <!-- We will need more changes here for Sabre, just show this for TFX for now(new ticket ENT-6375)-->
            @if (isTravelfusion) {
              <td>
                <app-ancillary-status-icon
                  [isReturnFlight]="isReturnFlight"
                  [ancillaryStatus]="transformedFareAncillaries[j].refund"
                ></app-ancillary-status-icon>
              </td>
            }
            @if (isTravelfusion) {
              <td>
                <app-ancillary-status-icon
                  [isReturnFlight]="isReturnFlight"
                  [ancillaryStatus]="transformedFareAncillaries[j].changes"
                ></app-ancillary-status-icon>
              </td>
            }
            @if (isReturnFlight) {
              <td class="border-left-mixed inbound-details">
                <div class="cabin-class">
                  {{ flight.inboundFlights[0].cabinClass | splitCamelCase | translate }}
                  @if (flight.inboundFlights[0].additional.fareBrand?.name) {
                    <span
                      >({{ flight.inboundFlights[0].additional.fareBrand?.name | titlecase }})
                      @if (showSaverAerLingusTravelfusionTooltip(flight)) {
                        <span class="tooltip_wrap">
                          <section (mouseleave)="tt.close()" class="container">
                            <i
                              class="currency_info_icon"
                              placement="top"
                              triggers="manual"
                              #tt="ngbTooltip"
                              (mouseenter)="tt.open()"
                              (focus)="tt.open()"
                              (blur)="tt.close()"
                              i18n-ngbTooltip
                              tabindex="0"
                              ngbTooltip="The fare inclusive hand baggage option you have chosen doesn't allow you to take the bag onboard. You can check your bag in at the airport free of charge which will then go into the hold or you can pay a small fee to carry your bag with you and place it in the overhead locker."
                              aria-label="The fare inclusive hand baggage option you have chosen doesn't allow you to take the bag onboard. You can check your bag in at the airport free of charge which will then go into the hold or you can pay a small fee to carry your bag with you and place it in the overhead locker."
                            >
                            </i>
                          </section>
                        </span>
                      }
                    </span>
                  }
                  @if (showMixedCabin(flight.inboundFlights)) {
                    <app-mixed-cabin-tooltip
                      [flights]="flight.inboundFlights"
                    ></app-mixed-cabin-tooltip>
                  }
                </div>
                <div class="seats-available">
                  @if (flight.inboundFlights[0].seatsAvailable) {
                    <i class="ico-plain-seat" aria-hidden="true"></i>
                    <span>{{ flight.inboundFlights[0].seatsAvailable }}</span>
                    <span i18n="@@flight_seatsLeft" class="sr-only">Seats left</span>
                  }
                  @if (!flight.inboundFlights[0].seatsAvailable) {
                    <span i18n="@@flight_SeatsUnknown">Number of seats unknown</span>
                  }
                  @if (
                    (flight.inboundFlights[0]?.bookingCode ||
                      flight.inboundFlights[0]?.cabinCode) &&
                    userIsAgent
                  ) {
                    <span>&nbsp;(</span>
                    <span>{{
                      flight.inboundFlights[0]?.bookingCode || flight.inboundFlights[0]?.cabinCode
                    }}</span>
                    <span>)</span>
                  }
                </div>
                <button
                  (click)="getRouteHappyInfo(flight, flight.inboundFlights)"
                  class="routehappy_button"
                  [disabled]="loadingRouteHappy"
                >
                  <span class="visuallyhidden">Inbound&nbsp;</span>
                  <span i18n="@@modalRoutehappyFlightDetail">Flight Details</span>
                  <span class="visuallyhidden">&nbsp;for {{ visuallyHiddenTexts[j] }} fare</span>
                </button>
              </td>
              @if (!isExchange || isPricingExchange) {
                <td>
                  <app-ancillary-status-icon
                    [isReturnFlight]="isReturnFlight"
                    [ancillaryStatus]="transformedFareAncillaries[j].hangBaggage"
                  ></app-ancillary-status-icon>
                </td>
                <td>
                  <b
                    >{{ searchParams.getTotalBaggage(flight, false) }}
                    @if (searchParams.getTotalBaggage(flight, false) !== 1) {
                      <span>
                        <span i18n="@@bags">bags</span>
                      </span>
                    } @else {
                      <span i18n="@@bag">bag</span>
                    }
                  </b>
                </td>
                <!-- We will need more changes here for Sabre, just show this for TFX for now(new ticket ENT-6375)-->
                @if (isTravelfusion) {
                  <td>
                    <app-ancillary-status-icon
                      [isReturnFlight]="isReturnFlight"
                      [ancillaryStatus]="transformedFareAncillaries[j].refund"
                    ></app-ancillary-status-icon>
                  </td>
                }
                @if (isTravelfusion) {
                  <td>
                    <app-ancillary-status-icon
                      [isReturnFlight]="isReturnFlight"
                      [ancillaryStatus]="transformedFareAncillaries[j].changes"
                    ></app-ancillary-status-icon>
                  </td>
                }
              }
            }
            @if (!isPricingExchange) {
              <td>
                @if (!isAerLingus) {
                  <button
                    class="fare_rules_link"
                    (click)="getFareRules(flight)"
                    (keydown.enter)="getFareRules(flight)"
                    [disabled]="searchParams.isLoadingFareRules"
                    tabindex="0"
                  >
                    <i class="currency_info_icon" aria-hidden="true"></i>
                    <span i18n="@@flightTypeTicketsFareRules">Fare Rules</span>
                    <span class="visuallyhidden">&nbsp;for {{ visuallyHiddenTexts[j] }} fare</span>
                  </button>
                }
                @if (isAerLingus) {
                  <a
                    class="fare_rules_link"
                    href="https://www.aerlingus.com/localized/en/modals/fare-rules.html"
                    target="_blank"
                    tabindex="0"
                    role="link"
                  >
                    <i class="ico-login fare_link_info_icon" aria-hidden="true"></i>
                    <span i18n="@@flightTypeTicketsFareRules">Fare Rules</span>
                    <span class="visuallyhidden">&nbsp;for {{ visuallyHiddenTexts[j] }} fare</span>
                  </a>
                }
                @if (isAerLingus) {
                  &nbsp; &nbsp;
                  <a
                    class="fare_rules_link"
                    href="https://www.aerlingus.com/support/booking-flexibility/cancelling-your-booking/"
                    target="_blank"
                    tabindex="0"
                    role="link"
                  >
                    <i class="ico-login fare_link_info_icon" aria-hidden="true"></i>
                    <span i18n="@@flightCancelRules">Cancellation Rules</span>
                  </a>
                }
                <div class="flight_leg_co2">
                  {{ flight.co2PerItem }} <span i18n="@@flight_kg">kg</span>&nbsp;<span
                    i18n="@@flight_leg_co2"
                    >CO</span
                  ><sub i18n="@@flight_leg_2">2</sub>&nbsp;<span i18n="@@flight_pp">pp</span>
                </div>
              </td>
            }
            @if (showNdc) {
              <td>
                @if (flight.source.toUpperCase().includes('NDC')) {
                  <div class="ndc-fare" i18n="@@ndcFareLabel">NDC</div>
                }
              </td>
            }
            <td>
              @if (showSpecialFares(flight)) {
                <div class="special-fares-container">
                  <app-special-fare-icon [flight]="flight"></app-special-fare-icon>
                </div>
              }
            </td>
            <td class="book-fare-wrapper">
              <!-- Note: If you need to make a change, be sure to check the "return dual" flight. -->
              @if (
                (flight?.requiresReasonKeys?.length ||
                  flight?.unavailable ||
                  fareRulesObject[flight.uid]) &&
                !isUnavailableDueToTime
              ) {
                <div>
                  <app-warning-tags
                    [iconId]="j"
                    [ticket]="flight || fareRulesObject[flight.uid]"
                    [displayCheck]="false"
                  ></app-warning-tags>
                </div>
              }
              @if (isUnavailableDueToTime) {
                <section (mouseleave)="ttUnavailableIcon.close()" class="container">
                  <fa-icon
                    class="time_error_icon"
                    container="body"
                    triggers="manual"
                    #ttUnavailableIcon="ngbTooltip"
                    (mouseenter)="ttUnavailableIcon.open()"
                    ngbTooltip="Invalid Selection: you cannot select a time that leaves before the departing journey has arrived, please choose an alternative."
                    i18n-ngbTooltip
                    attr.aria-label="Invalid Selection: you cannot select a time that leaves before the departing journey has arrived, please choose an alternative."
                    (focus)="ttUnavailableIcon.open()"
                    (blur)="ttUnavailableIcon.close()"
                    tabindex="0"
                    [icon]="faCalendarExclamation"
                  />
                  <span class="visuallyhidden">
                    Invalid Selection: you cannot select a time that leaves before the departing
                    journey has arrived, please choose an alternative.
                  </span>
                </section>
              }
              @if (userIsAgent && userService.bobo && !isTravelfusion) {
                <div class="reprice-container">
                  <button appButton="small" aria-label="Reprice" (click)="repriceFlight(flight)">
                    <span i18n="@@Reprice">Reprice</span>
                    <span class="visuallyhidden">&nbsp;{{ visuallyHiddenTexts[j] }}</span>
                  </button>
                </div>
              }
              <div
                class="price-container"
                #tooltipRef="ngbTooltip"
                triggers="manual"
                [ngbTooltip]="flight.source.toUpperCase().includes('NDC') ? 'NDC Fare' : null"
                [placement]="flight.source.toUpperCase().includes('NDC') ? 'top' : null"
                [container]="flight.source.toUpperCase().includes('NDC') ? 'body' : null"
              >
                <div class="flight-search-results__ticket-button-price">
                  @if (flight.total.price) {
                    @if (isExchange) {
                      <span>{{ flight.total.price > 0 ? '+' : '' }}</span>
                    }
                    <span
                      [ngbTooltip]="flight.source.toUpperCase().includes('NDC') ? 'NDC Fare' : null"
                      [placement]="flight.source.toUpperCase().includes('NDC') ? 'top' : null"
                      [container]="flight.source.toUpperCase().includes('NDC') ? 'body' : null"
                      >{{ flight.total.price | currency: flight.total.currency }}</span
                    >
                  }
                </div>
                <button
                  [ngClass]="{
                    'selected-button': searchParams.selectedFlight.value && isDualFlight
                  }"
                  [disabled]="
                    (fareRulesObject[flight.uid]?.unavailable && !canOverride) ||
                    (flight?.unavailable && !canOverride) ||
                    (disableItems && !checkAviability(flight.scheduleId)) ||
                    isUnavailableDueToTime
                  "
                  (click)="selectFare(flight)"
                  appButton="small"
                  class="fare_details_button"
                >
                  {{
                    ((searchParams.selectedFlight.value && isDualFlight) ||
                    searchParams.selectedFlight.value?.journeyHash === flight.journeyHash
                      ? 'Deselect'
                      : 'Select'
                    ) | translate
                  }}
                  <span class="visuallyhidden"
                    >{{ flight.total.price | currency: flight.total.currency }} fare</span
                  >
                </button>
                @if (checkIfSpanishResidencyApplies(flight)) {
                  <button
                    appButton="small"
                    class="fare_details_button spanish_button"
                    [disabled]="flight.total.discount"
                    [ngClass]="{ 'selected-button': flight.total.discount }"
                    i18n="@@ResidentDiscount"
                    (click)="searchParams.repriceFlight(flight)"
                  >
                    Resident Discount
                  </button>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
